import { createAppTableSaga, createAppTableStore } from 'components/AppTable/store';
import { createMigrate, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import apiRoutes from 'config/apiRoute';

export const projectTimeReportSlice = createAppTableStore({
  name: 'projectsTimeReport' as const,
  url: apiRoutes.PROJECT_TIME_REPORT,
  initialState: {
    params: {
      filters: {
        'projects.status': [{ value: 'paused' }, { value: 'waiting_to_launch' }, { value: 'in_progress' }, { value: 'active' }],
        'projects.plan': [
          { value: 'starter', label: 'Starter' },
          { value: 'premium', label: 'Premium' },
          { value: 'enterprise', label: 'Enterprise' },
          { value: 'custom', label: 'Custom' },
          { value: 'hosting', label: 'Hosting' },
        ],
        billable: [],
      },
      sort: { column: 'title', order: 'ascend' },
    },
    paramFilterFields: {
      advertising: 'filters[advertising][]',
      billable: 'filters[billable][]',
    },
    serverControl: false,
  },
  transformData: (data) => {
    return data.map((item) => {
      return {
        ...item,
        business_name: item.customer?.business_name,
        budget: item.budget,
        budget_total: item.budget?.total,
        budget_estimated: item.budget?.estimated,
        budget_spent: item.budget?.spent,
        budget_available: item.budget?.available,
        response_time_average_minutes: item.response_time?.average_minutes ?? null,
      };
    });
  },
});

export const projectsTimeReportSaga = createAppTableSaga(projectTimeReportSlice);

const defaultPlanFilters = [
  { value: 'starter', label: 'Starter' },
  { value: 'premium', label: 'Premium' },
  { value: 'enterprise', label: 'Enterprise' },
  { value: 'custom', label: 'Custom' },
  { value: 'hosting', label: 'Hosting' },
];

export const projectsTimeReportReducer = persistReducer(
  {
    key: projectTimeReportSlice.name,
    storage,
    whitelist: ['params'],
    version: 1,
    migrate: createMigrate(
      {
        1: (state: any) => {
          if (!state?.params?.filters?.['projects.plan']?.length) {
            return {
              ...state,
              params: {
                ...state?.params,
                filters: {
                  ...state?.params?.filters,
                  'projects.plan': defaultPlanFilters,
                },
              },
            };
          }

          return state;
        },
      },
      { debug: false },
    ),
  },
  projectTimeReportSlice.reducer,
);
